/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import {withRouter} from "react-router";

import {CognitoUserPool, CognitoUser} from 'amazon-cognito-identity-js';

import {Form,FormGroup,FormControl,Button} from 'react-bootstrap';

import Authentication from '../../../authentication/awsAuthentication';
import ActionResult from '../../../stores/ActionResult';
import UserStore from '../../../stores/UserStore';
import APIActions from '../../../actions/apiActions';

function getLoginState() {
    return {
        username : "",
        password : "",
        message : ""
    };
}

class LoginView extends React.Component {
    constructor(props) {
        console.log("[LoginView] - initialisation");

        super(props);
        this.onChangeUsername = this.onChangeUsername.bind(this)
        this.onChangePassword = this.onChangePassword.bind(this)
        this.onChangeNewPassword = this.onChangeNewPassword.bind(this);
        // this.resetPassword = this.resetPassword.bind(this);

        this.signIn = this.signIn.bind(this);
        this.forgotPassword = this.forgotPassword.bind(this);
        this.loginHandler = this.loginHandler.bind(this);
        this.onActionComplete = this.onActionComplete.bind(this);
        // this.userLoadHandler = this.userLoadHandler.bind(this);

        this._onUserChange = this._onUserChange.bind(this);
        this.state = getLoginState();
    }

    componentDidMount() {
        console.log("[LoginView] - componentDidMount");
        UserStore.addChangeListener(this._onUserChange) ;
    }

    componentWillUnmount() {
        console.log("[LoginView] - componentWillUnmount");
        UserStore.removeChangeListener(this._onUserChange);
    }

    _onUserChange() {
        var profile = UserStore.profile();
        console.log("[LoginView] - _onUserChange:", profile);

        if (profile) {
            // this.props.handler() ;
            this.props.history.push("/")
        }
        else {
            var s = this.state ;
            var f = UserStore.lastFailure() ;
            s.message = f ? JSON.stringify(f) : "Loading Profile...";
            this.setState(s);
        }
    }

    loginHandler(cs) {
        switch (cs.status) {
            case "OK":
                console.log("USERS LOADED:" + cs.result.username);
                var s = this.state ;
                s.message = "Please wait... Loading your profile" ;
                this.setState(s);
                APIActions.userByEmail(cs.result.username) ;
                break;
            case "FAIL":
                console.log("ERROR LOGGING IN");
                var s = this.state ;
                s.message = cs.error.message ;
                this.setState(s);
                break;
            default:
                break;
        }
    }

    onActionComplete(ss) {
        if (ss === undefined || ss === null) {
            return ; // shouldn't happen but just in case'
        }

        switch (ss.action) {
            case "LOGIN": this.loginHandler(ss.result); break ;
            default:
                break; // Unexpected result - not expected
        }
    }

    signIn(e){
        console.debug("[USER] validating: [" + this.state.username + "] pwd:[" + this.state.password + "]");
        var s = this.state ;
        s.message = "Please wait logging in...." ;
        this.setState(s);
        Authentication.login(this.state.username, this.state.password,ActionResult.make("LOGIN",this.onActionComplete));
    }

    onChangeUsername(u) {
        var name = u.target.value;
        var s = this.state ;
        s.username = name.toLowerCase() ;
        this.setState(s);
    }

    onChangePassword(p) {
        var pwd = p.target.value;
        var s = this.state ;
        s.password = pwd ;
        this.setState(s);
    }

    onChangeNewPassword(p) {
        var pwd = p.target.value;
        var s = this.state ;
        s.newPassword = pwd ;
        this.setState(s);
    }

    forgotPassword() {
        var poolData = {UserPoolId : 'us-east-1_MZfl3NXxa', ClientId : '1rkcjm9t0jhvmfcemehscchiud'};
        var userPool = new CognitoUserPool(poolData);
        var userData = {Username : this.state.username, Pool : userPool};

        let cognitoUser = new CognitoUser(userData);
        cognitoUser.forgotPassword({
            onSuccess: function (result) {
                alert("Please login with your new password");
            },
            onFailure: function(err) {
                alert(err);
            },
            //Optional automatic callback
            inputVerificationCode: function(data) {
                var verificationCode = prompt('Please input verification code ' ,'');
                var newPassword = prompt('Enter new password ' ,'');
                cognitoUser.confirmPassword(verificationCode, newPassword, this);
            }
        });
    }

    render() {
        return (
            <Form className="form-signin" horizontal onSubmit={event => event.preventDefault()}>
                <img src="/images/savaria-logo.png" alt=""/>
                <h2 className="form-signin-heading">Please login</h2>

                <FormControl onChange={this.onChangeUsername} type="text" placeholder="Email Address" ref="username" value={this.state.username}/>

                <FormControl onChange={this.onChangePassword} type="password" placeholder="Password" ref="password" value={this.state.password}/>

                <FormGroup>
                    <Button block type="button" bsSize="large" bsStyle="primary" onClick={this.signIn}>Login</Button>
                </FormGroup>

                <FormGroup>
                    <Button type="button" bsSize="small" bsStyle="danger" onClick={this.forgotPassword}>Forgot password?</Button>{'  '}
                </FormGroup>

                <div className="errorMessage">{this.state.message}</div>

            </Form>
        );
    }
}

export default withRouter(LoginView);



// WEBPACK FOOTER //
// ./src/app/components/admin/user/loginView.react.js